export class UserLayoutLang{
    
    public static general = {
                                lastAccess          : 'Last Access',
                                profile             : 20,
                                support             : 'Support Ticket',
                                logout              : 21,
                                dashboard           : 'Dashboard',
                                deadlines           : 38,
                                servicing           : 39,
                                listEquipment       : 40,
                                maintPlans          : 41,
                                humanRes            : 42,
                                employee            : 43,
                                notification        : 44,
                                medicalExam         : 45,
                                skills              : 81,
                                measTools           : 46,
                                listMeasTools       : 48,
                                calibPlans          : 49,
                                probSolving         : 50,
                                docManag            : 51,
                                customers           : 52,
                                consultancy         : 53,
                                contractList        : 54,
                                consReporting       : 55,
                                academy             : 56,
                                scheduledCourses    : 57,
                                courseCatalog       : 58,
                                qualifiedTeach      : 59,
                                project             : 60,
                                projectList         : 61,
                                projReporting       : 62,
                                projClass           : 63,
                                audit               : 64,
                                auditList           : 65,
                                auditStd            : 66,
                            }

}
